<script setup>
import { Container } from '@codinglabsau/ui'
import HeadMetaTags from '@/Components/HeadMetaTags.vue'
import Article from '@/Components/Blog/Article.vue'

defineProps({
  article: Object,
})
</script>

<template>
  <HeadMetaTags
    title="Blog"
    description="Updates and releases for Convict Records."
    :canonical="route('blog.show', article.slug)"
    :url="route('blog.show', article.slug)"
  />

  <Container :key="article.id">
    <div class="mx-auto max-w-2xl rounded-lg bg-white p-4">
      <Article :article="article" />
    </div>
  </Container>
</template>
